import React from 'react';

import { ViewEntityHeader } from 'components/entityViewer/ViewEntityHeader';
import { ViewEntityPage } from 'components/entityViewer/ViewEntityPage';
import { Card, CardContent, CardHeader, CardTitle } from 'shadcn/components/ui/Card';

const FC_TRANSFERS_LIST_HREF = '/warehouse/fc-transfers';

/**
 * FC Transfer create page entry (tech spec §2.1, §3.2). Full form and line-item flow ship in later tickets.
 */
export function CreateFCTransfer() {
    return (
        <div className="flex min-h-screen flex-col px-4 pb-8 pt-4">
            <ViewEntityPage
                header={
                    <ViewEntityHeader
                        backHref={FC_TRANSFERS_LIST_HREF}
                        backLabel="Back to FC Transfers"
                        entityIdentificationComponent={
                            <h1 className="text-2xl font-semibold tracking-tight text-foreground">
                                Create FC Transfer
                            </h1>
                        }
                    />
                }
                primaryInformationCard={
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-base font-medium">Transfer details</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <p className="text-sm text-muted-foreground">
                                Primary fields and line items will be added in follow-up work.
                            </p>
                        </CardContent>
                    </Card>
                }
            />
        </div>
    );
}

CreateFCTransfer.displayName = 'CreateFCTransfer';
